import { Layout } from 'antd';

import styles from './footer.module.css';

const year = new Date().getFullYear();

const Footer = () => (
    <Layout.Footer className={styles.footer}>
        Intrena &copy; {year}
    </Layout.Footer>
);

export default Footer;
